import angular from 'angular';

class UsersPermissionsModalContainer {
  constructor(
    $q,
    appEvents,
    appSessionCapabilities,
    brands,
    permissions,
    users,
    USERS_EVENTS,
  ) {
    'ngInject';

    this.$q = $q;
    this.appEvents = appEvents;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.permissions = permissions;
    this.users = users;
    this.USERS_EVENTS = USERS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.USERS_EVENTS.modal.open,
      (user, brandsList, forEdition) => this.openModal(
        user,
        angular.copy(brandsList),
        forEdition,
      ),
    );

    this.modalTitle = 'Assign Permissions';
    this.user = {};
    this.brandsList = [];
    this.editMode = false;
    this.canAssign = false;
    this.open = false;
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  updateModalTitle(brands) {
    const name = this.user.displayName;
    const twoBrandsOrMore = 2;
    let title = '';
    if (!this.canAssign) {
      const [brand] = brands;
      title = `View Permissions For ${brand.displayName}`;
    } else if (this.editMode && brands.length > 1) {
      title = `Update Permissions For ${brands.length} Selected Accounts`;
    } else if (this.editMode && brands.length === 1) {
      const [brand] = brands;
      title = `Update Permissions For ${brand.displayName}`;
    } else if (!this.editMode && brands.length < twoBrandsOrMore) {
      title = `Assign Account to ${name}`;
    } else {
      title = `Assign Accounts to ${name}`;
    }

    this.modalTitle = title;
  }
  openModal(user, brandsList, forEdition) {
    this.user = user;
    this.brandsList = brandsList;
    this.open = true;
    this.editMode = forEdition;
    this.canAssign = this.appSessionCapabilities.canAssignUserToNewBrand(this.user);
    this.updateModalTitle(this.brandsList);
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.USERS_EVENTS.modal.close);
  }
  saveModal() {
    this.appEvents.emit(this.USERS_EVENTS.modal.save);
    this.closeModal();
  }
}

export default {
  controller: UsersPermissionsModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
      full-height="true"
    >
      <permissions-form-container
        on-save="$ctrl.saveModal()"
        on-cancel="$ctrl.closeModal()"

        owner-label="Email"
        owner-caption="$ctrl.user.email"

        brands-list="$ctrl.brandsList"
        show-brands="true"
        can-add-brands="$ctrl.canAssign"
        can-remove-all-brands="!$ctrl.editMode"
        on-brands-change="$ctrl.updateModalTitle(brands)"

        users-list="[$ctrl.user]"
        show-users="false"
      ></permissions-form-container>
    </modal-wrapper>
  `,
};
